export const API_ROOT = (process.env.NODE_ENV === 'production') ?
  'http://api.ministerie-owcs.cw/api' :
  'http://api.ministerie-owcs.cw/api';
 //'http://localhost:8081/api';
//  'https://devefoapi.herokuapp.com'
//'https://devefoapi.herokuapp.com'

///usr/share/nginx/html/dist

//restorecon -RvF /usr/share/nginx/html/dist
